export default __webpack_public_path__ + "static/media/img-0052-usa-full-face.11ca7f89.png";